import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';

// Proto: schools.OptionSet.
export default class Set extends Model {
  declare [Type]: 'school-options/set';

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare description: string;
}
